module.exports = __webpack_public_path__ + "static/media/company-icon.91dbad90.svg";